import React from 'react'
import { connect } from 'react-redux'

import { BlueprintUpdater, BlueprintActions, BreadcrumbActions } from '~/actions'
import { BlueprintFactory } from '~/editors/blueprints'

import style from './style.css'

/**
 * @class BlueprintScreen — A screen for updating a Blueprint's info and attributes
 * @component 
 */
class BlueprintScreen extends React.Component {

  componentDidMount() {
    const { match, dispatch } = this.props
    dispatch( BlueprintActions.getBlueprint( match.params.projectId, match.params.blueprintId ) )
  }

  componentDidUpdate( nextProps ) { 
    const { dispatch } = this.props
    const { data : bp } = nextProps.blueprint
    if ( bp ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( [ 
        { name : 'Blueprints', link : `/project/${bp.projectId}/blueprint` }, 
        { name : bp.name } 
      ] ) )
    }
  }
  
  onBlueprintChange = ( event ) => {
    const { dispatch } = this.props 
    BlueprintUpdater( dispatch, event.target )
      .set( event.path, event.value )
      .done()
  }

  render() {
    const { blueprint } = this.props

    if ( blueprint == null ) {
      return null
    }
    const details = BlueprintFactory.createEditor( 
      blueprint.data, 
      { blueprint : blueprint.data, onChange : this.onBlueprintChange } 
    )
    
    return <div className={style.pad}>{details}</div>
  }
}

export default connect(
  state => ( {
    blueprint : state.blueprint,
  } )
)( BlueprintScreen )
